<template>
  <div class="index-page" id="index" ref="index">
    <!-- banner -->
    <div class="banner" ref="videoBg">
      <video
        v-if="!isMobile"
        :id="videoId"
        class="video video-js"
        crossOrigin="anonymous"
        playsinline
        controls
        muted
      >
        <source :src="videoUrl" />
      </video>
      <img v-else class="video-banner" :src="videoBanner" alt="" />
      <img class="banner-mask" :src="assets.bannerMask" alt="" />
      <div class="banner-slogan" :class="{ 'is-mobile': isMobile }">
        <img class="banner-title" :src="assets.bannerTitle" alt="" />
        <!--<h3>庆元保理</h3>-->
        <p class="info" v-html="bannerSlogan"></p>
      </div>
    </div>
    <!-- 业务优势 -->
    <div v-if="!isMobile" class="view-width view-section advantage-wrapper">
      <section-header
        :main-title="'业务优势'"
        :sub-title="'Business advantage'"
      ></section-header>
      <el-row :gutter="20" class="advantages">
        <el-col
          :xs="24"
          :sm="24"
          :md="8"
          :lg="8"
          :xl="8"
          class="advantage-item"
          v-for="(item, index) in advantages"
          :key="index"
        >
          <img class="bg" :src="item.bg" :alt="item.title" />
          <div class="info">
            <img class="slogan" :src="item.slogan" :alt="item.title" />
            <p class="text">{{ item.title }}</p>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 操作流程 -->
    <div
      v-if="!isMobile"
      class="view-section operation-wrapper"
      style="margin-top: -70px; padding-top: 70px"
    >
      <section-header
        :main-title="'操作流程'"
        :sub-title="'Operation process'"
      ></section-header>
      <div class="custom-tabs">
        <div class="tab-header">
          <div
            class="tab-header-item"
            :class="{ active: currentTab === 'ticket' }"
            @click="changeTab('ticket')"
          >
            票据保理
          </div>
          <div
            class="tab-header-item"
            :class="{ active: currentTab === 'contract' }"
            @click="changeTab('contract')"
          >
            合同保理
          </div>
        </div>
        <div class="tab-content">
          <div class="tab-content-item w-1200">
            <ticket-process v-if="currentTab === 'ticket'"></ticket-process>
            <contract-process
              v-if="currentTab === 'contract'"
            ></contract-process>
          </div>
        </div>
      </div>
    </div>
    <!-- 广告 -->
    <div v-if="!isMobile" class="view-section inquiry-advertisement">
      <img v-if="!isMobile" class="full-adverse" :src="assets.advertisement4" alt="优点" />
      <div v-else class="text">登录之后获取更精准报价</div>
    </div>

    <!-- 在线询价 -->
    <div id="inquiry" class="view-width view-section inquire-wapper">
      <section-header
        :main-title="'在线询价'"
        :sub-title="'Inquiry online'"
      ></section-header>
      <inquire></inquire>
    </div>
    <!-- 合作伙伴 -->
    <div class="view-section partner-wrapper">
      <h4 class="title">200+核心企业及2000+分子公司</h4>
      <div class="custom-tabs">
        <div class="tab-header">
          <div
            class="tab-header-item"
            :class="{ active: currentTabPartner === 'outside' }"
            @click="changeTabPartner('outside')"
          >
            全国
          </div>
          <div
            class="tab-header-item"
            :class="{ active: currentTabPartner === 'guangdong' }"
            @click="changeTabPartner('guangdong')"
          >
            广东省
          </div>
          <div
            class="tab-header-item"
            :class="{ active: currentTabPartner === 'inside' }"
            @click="changeTabPartner('inside')"
          >
            内蒙古自治区
          </div>
        </div>
        <div class="tab-content">
          <div class="tab-content-item w-1200">
            <partners :type="currentTabPartner"></partners>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoJs from "video.js";
import "video.js/dist/video-js.min.css";
import Inquire from "../inquiry/_form";
import Process from "./components/Operation/OperationProcess";
import Process1 from "./components/Operation/OperationProcess1";
import Partners from "./components/partners";

let videoIndex = 0;

export default {
  components: {
    "ticket-process": Process,
    "contract-process": Process1,
    inquire: Inquire,
    partners: Partners
  },
  data() {
    return {
      assets: {
        bannerMask: require("@/assets/img/banner/banner_mask.png"),
        bannerTitle: require("@/assets/img/banner/banner_title.png"),
        advertisement4: require("@/assets/img/banner/advertisement4_1.png")
      },
      videoId: "",
      player: null,
      advantages: [
        {
          title: "核心企业无感主动授信",
          bg: require("@/assets/img/banner/advertisement1.png"),
          slogan: require("@/assets/img/banner/advertisement1_1.png")
        },
        {
          title: "小微企业24小时随时询价",
          bg: require("@/assets/img/banner/advertisement2.png"),
          slogan: require("@/assets/img/banner/advertisement2_1.png")
        },
        {
          title: "小微企业三免（尽调、面签、担保）",
          bg: require("@/assets/img/banner/advertisement3.png"),
          slogan: require("@/assets/img/banner/advertisement3_1.png")
        }
      ],
      currentTab: "ticket",
      currentTabPartner: "outside",
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    videoUrl() {
      return `${process.env.BASE_URL || "./"}media/banner.mp4`;
    },
    videoBanner() {
      return `${process.env.BASE_URL || "./"}media/videoBanner.png`;
    },
    bannerSlogan() {
      return this.isMobile
        ? `深圳市庆源绿色商业保理有限公司2017年6月15日于深圳市前海自贸区注册，主营范围：应收账款转让下保理融资、与商业保理相关的咨询服务等。公司致力于供应链票据下小微企业保理融资服务解决方案。`
        : `深圳市庆源绿色商业保理有限公司2017年6月15日于深圳市<br />
          前海自贸区注册，主营范围：应收账款转让下保理融资、与<br />
          商业保理相关的咨询服务等。公司致力于供应链票据下小微<br />
          企业保理融资服务解决方案。`;
    }
  },
  watch: {
    isMobile: {
      // immediate: true,
      handler(val, oldVal) {
        if (!oldVal) return;
        if (val) return;

        videoIndex += 1;
        this.videoId = `video_banner_${videoIndex}`;

        this.$nextTick(() => {
          videoIndex += 1;
          this.videoId = `video_banner_${videoIndex}`;
        });
      }
    }
  },
  created() {
    this.updateVideoId();
  },
  mounted() {
    !this.isMobile && this.initPlayer();
  },
  methods: {
    updateVideoId() {
      if (this.isMobile) return;
      videoIndex += 1;
      this.videoId = `video_banner_${videoIndex}`;
    },
    initPlayer() {
      const options = {
        bigPlayButton: false,
        controlBar: false,
        loop: true
      };
      this.player = VideoJs(this.videoId, options);
      this.player.play();
    },

    removePlayer() {},

    changeTab(tab) {
      this.currentTab = tab;
    },

    changeTabPartner(tab) {
      this.currentTabPartner = tab;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/pages/index.scss";
</style>
